import { NgModule } from '@angular/core';

import { AvatarComponent } from './components/avatar/avatar.component';

@NgModule({
  imports: [AvatarComponent],
  exports: [AvatarComponent]
})
export class EmpathyUiModule {}
